<template>
    <div class="bg">
        <div>
            <img src="../assets/img/ba.png" alt="" class="back" @click="back">
        </div>
        <div class="logo_wrap flex_center">
            <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
            <div class="right_top_box">
                <div class="right_top_txt">{{ $t('PoweredbyMVGX') }}</div>
                <!-- <div class="right_top_txt_shu">|</div>
          <Kefu :sn='sn'></Kefu> -->
            </div>
        </div>
        <div class=" content_wrap">
            <div class="title">{{ detail.title }}</div>
            <div class="detail" v-html="detail.descriptions"></div>
        </div>
    </div>
</template>
<script>
import cnt from "@/api/cnt";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            sn: "",
            detail: JSON.parse(sessionStorage.getItem('detail')),
            config: '',
        };
    },
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        // this.getTravelRecord()
        // this.getUserEvent(1,1)
        console.log('detail', this.detail)
    },
    mounted() {
        this.sn = this.$route.query.sn;
    },
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        back() {
            this.$router.go(-1)
        },
        tab(index) {
            if (index == 1) {
                var data = {
                    sn: this.sn,
                    operationName: this.Digital,
                };
            } else if (index == 2) {
                var data = {
                    sn: this.sn,
                    operationName: this.World,
                };
            }
            cnt.getWelcome((res) => {
                if (res.id == 1) {
                    this.$router.push({ path: "/trip", query: { sn: this.sn } });
                } else if (res.id == -2) {
                    // this.$message.error('Serial number does not exist')
                    this.$message.error(this.$t('Sorrythecodelinked'))
                }
            }, data);
        },
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    if (!res) {
                        this.$router.push({ path: "/result", query: { sn: this.sn } });
                    } else if (res.snStatus == 1) {
                        this.$router.push({ path: "/info", query: { sn: this.sn } });
                    } else if (res.snStatus == 2) {
                        this.$router.push({ path: "/resultCard", query: { sn: this.sn } });
                    } else if (res.snStatus == null) {
                        if (res.operationName == null) {
                            this.$router.push({ path: '/welcome', query: { sn: this.sn } })
                        } else {
                            this.$router.push({ path: '/trip', query: { sn: this.sn } })
                        }
                    }
                },
                { sn: this.sn }
            );
        },
        helpDetail(item) {
            this.$router.push('/helpDetail')
        }
    },
};
</script>
<style lang="less" scoped>
.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    background: url("../assets/img/bj.png") no-repeat;

    background-size: 100% 100%;
}

.right_top_box {
    display: flex;
    align-items: center;

    .right_top_txt {
        font-size: 12px;
        font-family: Century Gothic;
        color: #EDFFFE;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }
}

.back {
    width: .8125rem;
    height: 1.375rem;
    margin: 2.5rem 1.25rem 0;
}

.logo {
    width: auto;
}

.power {
    font-size: .75rem;
    font-family: Century Gothic;
    color: #EDFFFE;
}

.flex_center {
    display: flex;
    justify-content: space-between;
    align-content: center;
}

.logo_wrap {
    margin: 1.25rem 1.25rem 2.1875rem;
}

.content_wrap {
    background-color: #ffffff;
    padding: 1.5625rem 1.25rem 2.1875rem;
    border-radius: 1.25rem 1.25rem 0 0;
    height: 100%;
}

.title {
    color: #303236;
    font-weight: bold;
    font-size: 1.1875rem;
    margin-bottom: 1.25rem;
}

.detail {
    font-size: .8125rem;
    color: #626262;
    line-height: 25px;
    white-space: pre-wrap;
}
</style>
